export {H1, H2, H3, H4, H5, H6} from "./Heading"
export {default as Body} from "./Body"
export {default as BodyProps} from "./Body/props"
export {default as Label} from "./Label"
export {default as Input} from "./Input"
export {default as Avatar} from "./Avatar"
